jQuery( document ).ready(function($) {

      if($('.information').length > 0)
      {
        $('.information .close').click(function(){
            $('.information').fadeOut();
        });
      }

});